import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { productImage, studioApi } from '@/lib/studioApi';
import { fromElement } from './model';

// KI-Vorlagen: motif + editable text fields, composed by the server for this article.
export const LibraryTemplates = ({ editor, setPanel, items }) => {
  const [busy, setBusy] = useState(null);
  const use = async t => {
    setBusy(t.id);
    try {
      const { elements } = await studioApi(`/library-graphics/${t.id.slice(4)}/template?product_id=${encodeURIComponent(editor.baseProduct.id)}`, { method: 'POST' });
      let last = null;
      elements.forEach(e => { const { id, ...o } = fromElement(e); last = editor.add(o.type, o) || last; });
      toast.success('Vorlage eingesetzt', { description: 'Tippe einen Text an, um ihn zu ändern.' }); setPanel('object');
    } catch (e) { toast.error(e.message); } finally { setBusy(null); }
  };
  if (!items?.length) return <p className="small-note" data-testid="library-templates-empty">Noch keine KI-Vorlagen für diesen Artikel.</p>;
  return <div className="shirt-templates" data-testid="library-templates">{items.map((t, i) => <button key={t.id} type="button" className="shirt-template" disabled={!!busy} onClick={() => use(t)} data-testid={`library-template-${i}`}>
    <span className="shirt-template-art"><img src={productImage(t.thumb)} alt={t.title} loading="lazy" />{busy === t.id && <Loader2 size={18} className="spin" />}</span>
    <strong>{t.title}</strong><small>{t.texts.map(x => `„${x}“`).join(' · ')} · änderbar</small>
  </button>)}</div>;
};
